"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _elementUi = require("element-ui");

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _userLogs = require("@/mixins/user-logs/user-logs");

var _noAuth = require("@/api/no-auth.api");

var _turnstile = _interopRequireDefault(require("@/components/turnstile/turnstile.vue"));

var _loginOtpForm = _interopRequireDefault(require("./components/login-otp-form/login-otp-form.vue"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// NOTE: seconds a user waits before asking for another emailed code
var OTP_RESEND_COOLDOWN = 60;

var LoginComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LoginComponent, _Mixins);

  var _super = _createSuper(LoginComponent);

  function LoginComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LoginComponent);
    _this = _super.apply(this, arguments);
    _this.otpState = {
      isOtpStep: false,
      isLoading: false,
      isSent: true,
      token: '',
      resendCountdown: 0
    }; // NOTE: kept in memory only, a resend replays the same credentials against the verify API

    _this.otpLoginData = null;
    _this.resendTimer = null; // NOTE: a Cloudflare Turnstile token is single use, every login call is verified with a fresh one.
    // Resending the OTP replays credentials that already passed the check, so that step skips it

    _this.turnstileToken = '';
    _this.passwordType = 'password';
    _this.formData = {
      username: '',
      password: '',
      rememberMe: true,
      isLogflows: true
    };
    return _this;
  }

  (0, _createClass2.default)(LoginComponent, [{
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json');
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.handleLocalStorage();
      var today = (0, _moment.default)(new Date()).format('YYYY-MM-DD');
      window.localStorage.setItem('AUTO_LOGOUT_DATE', today);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.configureRedirect();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.stopResendTimer();
    }
  }, {
    key: "configureRedirect",
    value: function configureRedirect() {
      if (window.localStorage.getItem('rQuery')) {
        this.$router.push({
          query: {
            r: window.localStorage.getItem('rQuery')
          }
        });
        window.localStorage.removeItem('rQuery');
      }
    }
  }, {
    key: "handleLocalStorage",
    value: function handleLocalStorage() {
      if (window.localStorage.getItem('isLoggedOut')) {
        window.localStorage.removeItem('isLoggedIn');
        window.localStorage.removeItem('isLoggedOut');
      }

      if (window.localStorage.getItem('hasNoAccess')) {
        var message = {
          title: this.$t('notification.logout.noAccess'),
          duration: 5000
        };

        _elementUi.Notification.error(message);

        window.localStorage.removeItem('isLoggedIn');
        window.localStorage.removeItem('hasNoAccess');
      }
    }
  }, {
    key: "submitLogin",
    value: function () {
      var _submitLogin = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loginData, isVerified;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.otpState['isLoading']) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.logger.info("form submitted: ".concat(JSON.stringify(this.formData)));
                loginData = {
                  username: (this.formData['username'] || '').trim(),
                  password: (this.formData['password'] || '').trim()
                };
                this.otpState['isLoading'] = true;
                _context.next = 7;
                return this.checkTurnstile();

              case 7:
                isVerified = _context.sent;
                // NOTE: the token was used up by the check, the next login call needs a new one
                this.resetTurnstile();

                if (isVerified) {
                  _context.next = 12;
                  break;
                }

                this.otpState['isLoading'] = false;
                return _context.abrupt("return");

              case 12:
                this.login(loginData);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submitLogin() {
        return _submitLogin.apply(this, arguments);
      }

      return submitLogin;
    }()
  }, {
    key: "onTurnstileVerify",
    value: function onTurnstileVerify(token) {
      this.turnstileToken = token;
    }
  }, {
    key: "onTurnstileExpire",
    value: function onTurnstileExpire() {
      this.turnstileToken = '';
    } // NOTE: the user is not told the widget failed, the widget hides itself and n8n decides
    // on login whether Turnstile is still required

  }, {
    key: "onTurnstileError",
    value: function onTurnstileError() {
      this.logger.error('Turnstile widget failed to load');
    } // NOTE: n8n decides whether Turnstile is switched on, so the check runs even without a token,
    // a switched off Turnstile always passes and a widget that failed to load blocks no one

  }, {
    key: "checkTurnstile",
    value: function () {
      var _checkTurnstile = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isVerified, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _noAuth.verifyTurnstile)(this.turnstileToken);

              case 2:
                isVerified = _context2.sent;

                if (!isVerified) {
                  message = {
                    title: this.turnstileToken ? this.$t('notification.login.captchaFailed') : this.$t('notification.login.captchaRequired'),
                    duration: 5000
                  };

                  _elementUi.Notification.warning(message);
                }

                return _context2.abrupt("return", isVerified);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function checkTurnstile() {
        return _checkTurnstile.apply(this, arguments);
      }

      return checkTurnstile;
    }()
  }, {
    key: "resetTurnstile",
    value: function resetTurnstile() {
      this.turnstileToken = '';
      var turnstile = this.$refs.turnstile;

      if (turnstile) {
        turnstile.reset();
      }
    }
  }, {
    key: "login",
    value: function login(loginData) {
      var _this2 = this;

      this.otpState['isLoading'] = true;
      this.$logInUser({
        loginData: loginData || '',
        remember: this.formData['rememberMe'] || true,
        logflows: this.formData['isLogflows'] || false
      }).then(function (res) {
        _this2.otpState['isLoading'] = false;

        if (!res.isSuccess) {
          var message = {
            title: _this2.$t('notification.login.failed'),
            duration: 5000
          };

          _elementUi.Notification.error(message);

          _this2.cancelOtp();

          _this2.formData['password'] = '';
          return;
        }

        if (res.hasOtp) {
          _this2.startOtpStep(loginData, res);

          return;
        }

        _this2.redirectAfterLogin(res.route);
      });
    }
  }, {
    key: "startOtpStep",
    value: function startOtpStep(loginData, res) {
      this.otpLoginData = loginData;
      this.otpState['token'] = res.otpToken || '';
      this.otpState['isSent'] = Boolean(res.isOtpSent);
      this.otpState['isOtpStep'] = true;

      if (this.otpState['isSent']) {
        var message = {
          title: this.$t('notification.login.otpSent'),
          duration: 5000
        };

        _elementUi.Notification.success(message);
      }

      this.startResendTimer();
    }
  }, {
    key: "verifyOtp",
    value: function verifyOtp(passwordKey) {
      var _this3 = this;

      this.otpState['isLoading'] = true;
      this.$verifyOtp({
        token: this.otpState['token'],
        passwordKey: passwordKey,
        remember: this.formData['rememberMe'] || true
      }).then(function (res) {
        _this3.otpState['isLoading'] = false;

        if (!res.isSuccess) {
          var message = {
            title: _this3.$t('notification.login.otpInvalid'),
            duration: 5000
          };

          _elementUi.Notification.error(message);

          var otpForm = _this3.$refs.otpForm;

          if (otpForm) {
            otpForm.clearCode();
          }

          return;
        }

        _this3.stopResendTimer();

        _this3.otpLoginData = null;

        _this3.redirectAfterLogin(res.route);
      });
    }
  }, {
    key: "resendOtp",
    value: function resendOtp() {
      if (!this.otpLoginData) {
        this.cancelOtp();
        return;
      }

      this.login(this.otpLoginData);
    }
  }, {
    key: "cancelOtp",
    value: function cancelOtp() {
      this.stopResendTimer();
      this.otpLoginData = null;
      this.otpState['isOtpStep'] = false;
      this.otpState['isLoading'] = false;
      this.otpState['isSent'] = true;
      this.otpState['token'] = '';
    }
  }, {
    key: "startResendTimer",
    value: function startResendTimer() {
      var _this4 = this;

      this.stopResendTimer();
      this.otpState['resendCountdown'] = OTP_RESEND_COOLDOWN;
      this.resendTimer = setInterval(function () {
        _this4.otpState['resendCountdown'] = Math.max(_this4.otpState['resendCountdown'] - 1, 0);

        if (_this4.otpState['resendCountdown'] === 0) {
          _this4.stopResendTimer();
        }
      }, 1000);
    }
  }, {
    key: "stopResendTimer",
    value: function stopResendTimer() {
      if (this.resendTimer) {
        clearInterval(this.resendTimer);
        this.resendTimer = null;
      }

      this.otpState['resendCountdown'] = 0;
    }
  }, {
    key: "redirectAfterLogin",
    value: function redirectAfterLogin(routePath) {
      window.localStorage.setItem('isLoggedIn', '1');
      window.localStorage.setItem('rld', '1');
      var url = {
        path: routePath
      };

      if (this.$route.query.r) {
        url['query'] = {
          r: this.$route.query.r
        };
      } // Insert log
      // const ip = await this.helper.getIPAddress();
      // const ip: string = '111.111.111.111';
      // await this.insertLogInLogs({ user: this.formData['username'], ip });


      this.$router.push(url);
    }
  }, {
    key: "showPwd",
    value: function showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
    }
  }]);
  return LoginComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _userLogs.UserLogsMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Action)('logInUser', {
  namespace: 'authentication'
})], LoginComponent.prototype, "$logInUser", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('verifyOtp', {
  namespace: 'authentication'
})], LoginComponent.prototype, "$verifyOtp", void 0);
LoginComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LoginComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-switch': _elementUi.Switch,
    'el-checkbox': _elementUi.Checkbox,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button,
    'el-input': _elementUi.Input,
    'el-card': _elementUi.Card,
    'login-otp-form': _loginOtpForm.default,
    'turnstile': _turnstile.default
  }
})], LoginComponent);
var _default = LoginComponent;
exports.default = _default;